export default "__VITE_ASSET__B1VH1F6O__"